import { render } from "./UseTermText.vue?vue&type=template&id=b7e7e8fa&scoped=true"
import script from "./UseTermText.vue?vue&type=script&lang=js"
export * from "./UseTermText.vue?vue&type=script&lang=js"

import "./UseTermText.vue?vue&type=style&index=0&id=b7e7e8fa&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7e7e8fa"]])

export default __exports__